import {
  PRECIO_JUSTO_ACT_GET_BRANDS_BEGIN,
  PRECIO_JUSTO_ACT_GET_BRANDS_SUCCESS,
  PRECIO_JUSTO_ACT_GET_BRANDS_FAILURE,
  PRECIO_JUSTO_ACT_GET_BRANDS_DISMISS_ERROR,
} from './constants'
import axios from 'axios'
import { DATAMASTER_ENDPOINT } from 'common/endpoints';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function actGetBrands() {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PRECIO_JUSTO_ACT_GET_BRANDS_BEGIN,
    })

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(`${DATAMASTER_ENDPOINT}/brands`)

      doRequest.then(
        (res) => {
          res.data.data.forEach(brand => {
            brand.value = brand.id
            brand.label = brand.name
            brand.type = 'brand'
          })
          dispatch({
            type: PRECIO_JUSTO_ACT_GET_BRANDS_SUCCESS,
            data: res.data,
          })
          resolve(res)
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PRECIO_JUSTO_ACT_GET_BRANDS_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissActGetBrandsError() {
  return {
    type: PRECIO_JUSTO_ACT_GET_BRANDS_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRECIO_JUSTO_ACT_GET_BRANDS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        actGetBrandsPending: true,
        actGetBrandsError: null,
      }

    case PRECIO_JUSTO_ACT_GET_BRANDS_SUCCESS:
      // The request is success
      return {
        ...state,
        actGetBrandsPending: false,
        actGetBrandsError: null,
        brands: action.data,
      }

    case PRECIO_JUSTO_ACT_GET_BRANDS_FAILURE:
      // The request is failed
      return {
        ...state,
        actGetBrandsPending: false,
        actGetBrandsError: action.data.error,
      }

    case PRECIO_JUSTO_ACT_GET_BRANDS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        actGetBrandsError: null,
      }

    default:
      return state
  }
}
